import Image from 'next/image'
import React, { ComponentType, SVGProps, useLayoutEffect, useRef } from 'react'

import imgGuaranteeIcon from '@/screens/Product/page/assets/icon.png'

import { useMedia } from '@/shared/lib/hooks/useMedia'
import { Icon } from '@/shared/ui/icon'
import { Popover } from '@/shared/ui/Popover'

import styles from './styles.module.scss'

export type ItemType = {
	type: 'icon' | 'image'
	iconId?: ComponentType<SVGProps<SVGSVGElement>>
	src?: string
	alt?: string
	title: string
	subtitle: string
}

type TitleWithTriggersProps = {
	title: string
	items: ItemType[]
	nonTitle?: boolean
	showRustore?: boolean
}

export const TitleWithTriggers: React.FC<TitleWithTriggersProps> = ({ title, items, nonTitle, showRustore }) => {
	const { isLessThan } = useMedia()
	const isMobile = isLessThan(`992px`)
	const trigger = isMobile ? `click` : `hover`
	const listRef = useRef<HTMLUListElement>(null)

	useLayoutEffect(() => {
		listRef.current?.querySelectorAll('svg').forEach(svg => {
			if (svg.getAttribute('viewBox')) return

			const width = svg.getAttribute('width') || '40'
			const height = svg.getAttribute('height') || '40'
			svg.setAttribute('viewBox', `0 0 ${width} ${height}`)
		})
	}, [items, showRustore])

	return (
		<div className={styles.CatalogDiscount__TopPanel}>
			{nonTitle ? (
				<p className={styles.CatalogDiscount__TopPanelTitle}>{title}</p>
			) : (
				<h1 className={styles.CatalogDiscount__TopPanelTitle}>{title}</h1>
			)}
			<ul ref={listRef} className={`${styles.CatalogDiscount__TopPanelList} ${styles.listReset}`}>
				{showRustore && (
					<li className={styles.CatalogDiscount__TopPanelItem}>
						<Popover
							trigger={trigger}
							content={
								<div className={styles.ProductGuaranteeTooltip}>
									Уведомляем Вас об отсутствии в товарах марки Apple предустановленного приложения RuStore и иных
									программ согласно Распоряжению Правительства РФ от 25.07.2024 N 1972-р, а также невозможности их
									установки в настоящее время.
									<br />
									<br />В связи с отсутствием приложения RuStore Вы не можете устанавливать различные мобильные
									приложения, если они недоступны в фирменном магазине Apple, а также осуществлять их оплату при покупке
									приложений и обновления приложений в RuStore или иных, в т.ч. фирменных магазинах приложений на
									устройствах Apple
									{/*<Link href="/space" legacyBehavior>*/}
									{/*	<a target="_blank">Подробнее</a>*/}
									{/*</Link>*/}
								</div>
							}
							placement="bottomLeft">
							<div className={styles.GuaranteeLink}>
								<Image src={imgGuaranteeIcon} alt="Без Rustore" width="30" height="30" />
								<span>
									<span>Без приложения RuStore</span>
								</span>
							</div>
						</Popover>
					</li>
				)}
				{items.map((item, index) => (
					<li key={index} className={styles.CatalogDiscount__TopPanelItem}>
						{item.type === 'icon' && item.iconId ? (
							<Icon icon={item.iconId} width={40} height={40} />
						) : item.type === 'image' && item.src && item.alt ? (
							<Image
								alt={item.alt}
								src={item.src}
								width={40}
								height={40}
								className={styles.CatalogDiscount__TopPanelImage}
							/>
						) : null}
						{item.title} <br />
						{item.subtitle}
					</li>
				))}
			</ul>
		</div>
	)
}
